import { h } from "preact";
import { CosmosText, CosmosTitle } from "@cosmos/web/preact";
import classNames from "classnames";
import styles from "./Leaderboard.module.css";

export type LeaderboardEntry = {
  attributes: {
    finished_at: string;
    id: string;
    yours: boolean;
    position: number;
    score: number;
    name: string;
  };
  id: string;
  links: {
    self: string;
  };
  relationships: unknown;
  type: string;
};

export type LeaderboardData = Array<LeaderboardEntry>;

export type LeaderboardProps = {
  title: string;
  leaderboardData: LeaderboardData;
};

export function Leaderboard({ leaderboardData, title }: LeaderboardProps) {
  return (
    <div className={styles.container}>
      <CosmosTitle
        tag="h2"
        style={{ textTransform: "uppercase" }}
        weight="bold"
      >
        {title}
      </CosmosTitle>
      <div className={styles.leaderboard}>
        <ul className={styles.items}>
          {leaderboardData
            .filter((entry) => entry.attributes.position < 11)
            .map((entry) => (
              <LeaderboardEntry {...entry}></LeaderboardEntry>
            ))}
        </ul>
      </div>
    </div>
  );
}

function LeaderboardEntry({
  attributes: { position, name, score },
}: LeaderboardEntry) {
  return (
    <li
      className={classNames(styles.item, {
        [styles["item--underlined"]]: position === 1,
      })}
    >
      <CosmosText
        className={classNames(styles.item__position, {
          [styles["item__position--large"]]: position === 1,
        })}
        tag="span"
        size="small"
      >
        {`${position}.`}
      </CosmosText>

      <CosmosText className={styles.name} tag="span" size="small">
        {name}
      </CosmosText>

      <CosmosText className={styles.score} tag="span" size="small">
        {score ?? "/"}
      </CosmosText>
    </li>
  );
}
